import { useSelector } from "react-redux";

const EstilosPerfil = () => {
  const idTipoPerfil = useSelector(
    (state) => state.appStatus.sesion.PerfilActual.idTipoPerfil
  );

  /* eslint-disable */
  switch (idTipoPerfil) {
    case 1:
      import("../styles/perfilTrabajador.scss");
      break;
    case 2:
    case 3:
    case 4:
      import("../styles/perfilEmpleador.scss");
      break;
    case 5:
      import("../styles/perfilSindicato.scss");
      break;
    default:
      import("../styles/perfilTrabajador.scss");
      break;
  }

  return null;
};
/* eslint-enable */

export default EstilosPerfil;
